import { render, staticRenderFns } from "./atendimento_nova_anaminese.vue?vue&type=template&id=1ad0ac82&scoped=true"
import script from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js"
export * from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js"
import style0 from "./atendimento_nova_anaminese.vue?vue&type=style&index=0&id=1ad0ac82&prod&scoped=true&lang=css"
import style1 from "./atendimento_nova_anaminese.vue?vue&type=style&index=1&id=1ad0ac82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0ac82",
  null
  
)

export default component.exports